import { Icon56GlobeCrossOutline } from '@vkontakte/icons';
import { Spacing, Title } from '@vkontakte/vkui';
import React, { memo, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { IS_CHECK_AB } from 'reactApp/appHelpers/featuresHelpers/features/checkAB';
import { BaseConfirmDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog';
import { EButtonType } from 'reactApp/components/BaseConfirmDialog/BaseConformationDialog.types';
import { getCheckABStatus } from 'reactApp/modules/checkAB/checkAB.selectors';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { sendDwh } from 'reactApp/utils/ga';
import { ECategoryGa } from 'reactApp/utils/paymentGa';

import styles from './CheckABModal.css';

export const CheckABModal = memo(() => {
    const storage = useSelector(getCurrentStorage);
    const isPhone = useSelector(EnvironmentSelectors.isPhone);
    const isWebview = useSelector(EnvironmentSelectors.isWebview);
    const isCheckAB = useSelector(getCheckABStatus);

    useEffect(() => {
        sendDwh({
            eventCategory: ECategoryGa.alertVpn,
            action: 'show',
            dwhData: {
                vpn_check_enabled: IS_CHECK_AB,
                platform: isPhone ? 'touch' : 'web',
                webview: isWebview,
                is_vpn: isCheckAB,
                storage,
            },
            dwh_enabled_fields: [['is_vpn', 'platform', 'storage']],
        });
    }, []);

    const handleOnClick = useCallback(() => {
        sendDwh({
            eventCategory: ECategoryGa.alertVpn,
            action: 'click',
            dwhData: {
                vpn_check_enabled: IS_CHECK_AB,
                platform: isPhone ? 'touch' : 'web',
                webview: isWebview,
                is_vpn: isCheckAB,
                storage,
            },
            dwh_enabled_fields: [['is_vpn', 'platform', 'storage']],
        });
        window.location.reload();
    }, []);

    return (
        <BaseConfirmDialog
            successButtonText="Обновить страницу"
            onSuccess={handleOnClick}
            renderContent={() => (
                <div className={styles.wrapper}>
                    <Icon56GlobeCrossOutline className={styles.icon} />
                    <Title level="2">У вас включён VPN</Title>
                    <div className={styles.subTitle}>Отключите его, чтобы сервис работал корректно</div>
                    <Spacing size={8} />
                </div>
            )}
            closable={false}
            buttons={[EButtonType.accept]}
            footerClassName={styles.footer}
        />
    );
});

CheckABModal.displayName = 'CheckABModal';
